import { render, staticRenderFns } from "./OrderDetailDialog.vue?vue&type=template&id=e57243de&scoped=true&"
import script from "./OrderDetailDialog.vue?vue&type=script&lang=js&"
export * from "./OrderDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e57243de",
  null
  
)

export default component.exports